import TicketIcon from '@atlaskit/icon-lab/core/ticket';
import * as React from 'react';

export function SvgCreateTicket() {
  return <TicketIcon label="" testId="ads-refreshed-icon" />;
}
